import axios from 'axios';
import {
    FEEDBACK_LIST_REQUEST, FEEDBACK_LIST_SUCCESS, FEEDBACK_LIST_FAIL,
    FEEDBACK_DETAILS_REQUEST, FEEDBACK_DETAILS_SUCCESS, FEEDBACK_DETAILS_FAIL,
    FEEDBACK_CREATE_REQUEST, FEEDBACK_CREATE_SUCCESS, FEEDBACK_CREATE_FAIL,
    FEEDBACK_UPDATE_REQUEST, FEEDBACK_UPDATE_SUCCESS, FEEDBACK_UPDATE_FAIL,
    FEEDBACK_DELETE_REQUEST, FEEDBACK_DELETE_SUCCESS, FEEDBACK_DELETE_FAIL,
    FEEDBACK_DTO_REQUEST, FEEDBACK_DTO_SUCCESS, FEEDBACK_DTO_FAIL,
    FEEDBACK_LIST_BYIDS_REQUEST, FEEDBACK_LIST_BYIDS_SUCCESS, FEEDBACK_LIST_BYIDS_FAIL,
} from '../constants/feedbackConstants';

const getAuthConfig = (token) => ({
    headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${token}`
    }
});

const formatErrorMessage = (error) => {
    const errorMessages = [];
    if (error.response?.data) {
        if (error.response.data.errors) {
            Object.entries(error.response.data.errors).forEach(([key, value]) => {
                errorMessages.push(`${key}: ${value[0]}`);
            });
        }
        if (error.response.data.detail) {
            errorMessages.push(`Detail: ${error.response.data.detail}`);
        }
        if (error.response.data.message) {
            errorMessages.push(`Message: ${error.response.data.message}`);
        }
    }
    return errorMessages.length > 0 ? errorMessages : [error.message || "An error occurred, please try again later"];
};

const API_BASE_URL = '/dotnet_api/v1/feedback';

export const listFeedbacks = (params = {}) => async (dispatch, getState) => {
    try {
        dispatch({ type: FEEDBACK_LIST_REQUEST });
        const config = {
            ...getAuthConfig(getState().userLogin.userInfo.token),
            params: {
                ...params,
                order: params.sortOrder || 'ASC'
            }
        };

        const { data } = await axios.get(`${API_BASE_URL}/all`, config);

        dispatch({
            type: FEEDBACK_LIST_SUCCESS,
            payload: {
                items: data.items,
                totalCount: data.totalCount,
                totalPages: Math.ceil(data.totalCount / params.pageSize),
                currentPage: params.pageNumber,
                statistics: data.statistics
            }
        });
    } catch (error) {
        dispatch({
            type: FEEDBACK_LIST_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const getFeedbackDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: FEEDBACK_DETAILS_REQUEST });
        const { data } = await axios.get(
            `${API_BASE_URL}/${id}`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: FEEDBACK_DETAILS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: FEEDBACK_DETAILS_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const listFeedbacksByIds = (ids) => async (dispatch, getState) => {
    try {
        dispatch({ type: FEEDBACK_LIST_BYIDS_REQUEST });
        const { data } = await axios.post(
            `${API_BASE_URL}/ids/all`,
            ids,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: FEEDBACK_LIST_BYIDS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: FEEDBACK_LIST_BYIDS_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const createFeedback = (feedbackData) => async (dispatch, getState) => {
    try {
        dispatch({ type: FEEDBACK_CREATE_REQUEST });
        const { data } = await axios.post(
            API_BASE_URL,
            feedbackData,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: FEEDBACK_CREATE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: FEEDBACK_CREATE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const updateFeedback = (id, changes) => async (dispatch, getState) => {
    try {
        dispatch({ type: FEEDBACK_UPDATE_REQUEST });
        const { data } = await axios.patch(
            `${API_BASE_URL}/${id}`,
            changes,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: FEEDBACK_UPDATE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: FEEDBACK_UPDATE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const deleteFeedback = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: FEEDBACK_DELETE_REQUEST });
        await axios.delete(
            `${API_BASE_URL}/${id}`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: FEEDBACK_DELETE_SUCCESS });
    } catch (error) {
        dispatch({
            type: FEEDBACK_DELETE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const getFeedbackDto = () => async (dispatch, getState) => {
    try {
        dispatch({ type: FEEDBACK_DTO_REQUEST });
        const { data } = await axios.get(
            `${API_BASE_URL}/dto`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: FEEDBACK_DTO_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: FEEDBACK_DTO_FAIL,
            payload: formatErrorMessage(error)
        });
    }
}; 